export var ANIMATRON_PROD = 'https://www.animatron.com/';
export var ANIMATRON_API_PROD = 'https://api.animatron.com/';
export var ANIMATRON_ASSETS_PROD = 'https://assets.animatron.com/';
export var ANIMATRON_LIBRARY_PROD = 'https://library.animatron.io/';
export var WAVE_DEV = "http://localhost:3005/";
export var WAVE_PROD = 'https://wave.video/';
export var WAVE_API_PROD = 'https://api.wave.video/';
export var WAVE_WATCH_PROD = 'https://watch.wave.video/';
export var WAVE_EMBED_PROD = 'https://embed.wave.video/';
export var WEBINAR_PROD = 'https://webinar.mywave.video/';
export var YOUTUBE_API_PROD = 'https://youtube-dl.wave.video';
export var ANIMATRON_TEST = 'https://www.animatron-test.com/';
export var ANIMATRON_API_TEST = 'https://api.animatron-test.com/';
export var ANIMATRON_ASSETS_TEST = 'https://assets.animatron-test.com/';
export var ANIMATRON_LIBRARY_TEST = 'https://animatron-test-library.s3.amazonaws.com/';
export var WAVE_TEST = 'https://wave-test.video/';
export var WAVE_API_TEST = 'https://api.wave-test.video/';
export var WAVE_WATCH_TEST = 'https://watch.wave-test.video/';
export var WAVE_EMBED_TEST = 'https://embed.wave-test.video/';
export var WEBINAR_TEST = 'https://webinar-test.mywave.video/';
export var YOUTUBE_API_TEST = 'https://youtube-dl.test.stacks.animatron-test.com';
export var PLAYER_ANALYTICS_DEV = 'http://localhost:9002/';
export var PLAYER_ANALYTICS_TEST = 'https://ingest.test.stacks.animatron-test.com/';
export var PLAYER_ANALYTICS_PROD = 'https://ingest.animatron.com/';
export var BUNNY_CDN_1_TEST = 'https://cdn1-test.mywave.video/';
export var BUNNY_CDN_2_TEST = 'https://cdn2-test.mywave.video/';
export var BUNNY_CDN_1_PROD = 'https://cdn1.mywave.video/';
export var BUNNY_CDN_2_PROD = 'https://cdn2.mywave.video/';
export var GIPHY = 'https://d2bfg3hktrwrnd.cloudfront.net/v1/stickers';
export var SEMRUSH_TEST = "https://www.semrush.com/app/wave-video-test/";
export var SEMRUSH_PROD = "https://www.semrush.com/app/wave-video/";